<template>
   <div class="over_layout">
      <section class="upgrade">
         <a style="cursor: pointer" @click="$store.commit('paymentModal', true)">
            {{ $store.getters.t('create_resume') }}</a>
      </section>
      <section>
         <div>
            <div class="pages_header">
               <div class="lines">
                  <h1> MAP </h1>
               </div>
               <div style="margin-top: 50px;">
                  <GmapMap
                      :center="{lat: +$route.query.lat, lng: +$route.query.lng}"
                      :zoom="13"
                      style="width: 100%; height: calc(100vh - 215px);"
                  >
                     <GmapMarker
                         :position="{lat: +$route.query.lat, lng: +$route.query.lng}"
                         :clickable="true"
                         :draggable="true"
                         @click="center={lat: +$route.query.lat, lng: +$route.query.lng}"
                     />
                  </GmapMap>
               </div>

            </div>
         </div>
      </section>
   </div>
</template>
<script>
  export default {
    mounted() {
      this.$parent.getData().then(changed => {
        if (changed) {
        }
      });
    }
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/map/Map.vue